const fonts = [
  'Amatic SC',
  'Architects Daughter',
  'Average',
  'Balsamiq Sans',
  'Berkshire Swash',
  'Bubblegum Sans',
  'Caveat',
  'Chelsea Market',
  'Chewy',
  'Dancing Script',
  'Emilys Candy',
  'Fondamento',
  'Fredericka the Great',
  'Grand Hotel',
  'Homemade Apple',
  'Indie Flower',
  'Kaushan Script',
  'Lobster',
  'Luckiest Guy',
  'Nunito',
  'Permanent Marker',
  'Ranchers',
  'Rock Salt',
  'Sacramento'
];

// These are all based on the material color palette
// https://vuetifyjs.com/en/styles/colors/
const colors = [
  '#000000',
  '#9E9E9E',
  '#FEFEFE',
  '#795548',
  '#D32F2F',
  '#FB8C00',
  '#FDDB29',
  '#43A047',
  '#1E88E5',
  '#1A237E',
  '#9C27B0',
  '#F06292'
];
const lightColors = [ '#FEFEFE', '#FDDB29' ];

const frames = [
  null,
  'paper',
  'tape',
  'tacks',
  'wood',
  'glass',
  'gold',
  'metal'
];

const textSizeRange = [ 18, 480 ];

export { fonts, colors, lightColors, frames, textSizeRange };
